import { Button, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { useRecordContext } from "react-admin";
import { Controller, useForm } from "react-hook-form";
import CustomProductSelect from "../../unit/forms/CustomProductSelect";
import FieldTitle from "./FieldTitle";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import CustomProductActionBottom from "../CustomProductActionBottom";

export default function ServicingRepayment({
  onSave,
  defaultValues,
  ...props
}: any) {
  const record = useRecordContext();
  const sectionName = "servicing_repayment";
  let sectionTitle =
    "Servicing - Provide accounts used for disbursement and repayments";
  const sectionSubtitle = "";
  const productType = record?.data?.basic?.type;
  const subType = record?.data?.basic?.subType;
  const division = record?.data?.basic?.division;
  const productModulesGroup = record?.data?.basic?.productModulesGroup;

  if (productType == "account") {
    sectionTitle =
      "Servicing - Designated process and accounts used for transferring payments";
  } else if (subType == "securedcreditcard") {
    sectionTitle = "Servicing - Provide accounts used for repayments";
  } else {
    sectionTitle =
      "Servicing - Provide accounts used for disbursement and repayments";
  }

  // const data = record?.data?.basic?.sectionName;
  const data = record?.data?.basic?.servicing;
  const accountList = data?.accountList;

  type Account = {
    id?: string;
    sInstitutionName?: string;
    sAccountType?: string;
    sAccountNumber?: string;
    sRoutingNumber?: string;
  };

  const accountRepaymentOptions: any[] | undefined = [];
  if (accountList) {
    Object.entries(accountList).forEach(([key, value]) => {
      const account = value as Account;
      accountRepaymentOptions.push({
        value: account?.id,
        label:
          (account?.sInstitutionName || "") +
          " " +
          (account?.sAccountType || "") +
          " " +
          (account?.sAccountNumber || ""),
      });
    });
  }
  const accountOptions: any[] | undefined = [];
  if (accountList) {
    Object.entries(accountList).forEach(([key, value]) => {
      const account = value as Account;
      accountOptions.push({
        value: account?.id,
        label:
          (account?.sInstitutionName || "") +
          " " +
          (account?.sAccountType || "") +
          " " +
          (account?.sAccountNumber || ""),
      });
    });
  }
  accountOptions.push({
    value: "dwolla_balance",
    label: "Dwolla Balance",
  });

  const [showRepaymentStep2, setShowRepaymentStep2] = React.useState(false);
  const [showRepaymentStep3, setShowRepaymentStep3] = React.useState(false);
  const [showRepaymentStep4, setShowRepaymentStep4] = React.useState(false);
  const [showRepaymentStep5, setShowRepaymentStep5] = React.useState(false);
  const [showRepaymentStep6, setShowRepaymentStep6] = React.useState(false);
  const [showRepaymentStep5AccountType, setShowRepaymentStep5AccountType] =
    React.useState(false);
  const [showRepaymentStep5AccountId, setShowRepaymentStep5AccountId] =
    React.useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
    setValue,
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      repayment_ach: data?.repayment_ach || "",
      repayment_smart_ach: data?.repayment_smart_ach || "",
      repayment_collect: data?.repayment_collect || "",
      deposit_collect: data?.deposit_collect || "",
      sProductAlerts: data?.sProductAlerts || "",
      sProductRequiredEnterAccountNumber:
        data?.sProductRequiredEnterAccountNumber || "",
      repayment_to_account: data?.repayment_to_account || "",
      repayment_account_type: data?.repayment_account_type || "",
      use_repayment_account: data?.use_repayment_account || "",
      sVerifiedFundingSource: data?.sVerifiedFundingSource || "",
    },
  });

  // {
  //   "repayment_ach": "YES",
  //   "repayment_smart_ach": "NO",
  //   "repayment_collect": "NO",
  //   "deposit_collect": "",
  //   "sProductAlerts": "event_pmt_transfer_scheduled",
  //   "repayment_to_account": "",
  //   "repayment_account_type": "",
  //   "use_repayment_account": "",
  //   "sVerifiedFundingSource": "",
  //   "saveAction": "servicing_repayment"
  // }

  React.useEffect(() => {
    if (data) {
      reset({
        repayment_ach: data?.repayment_ach || "",
        repayment_smart_ach: data?.repayment_smart_ach || "",
        repayment_collect: data?.repayment_collect || "",
        deposit_collect: data?.deposit_collect || "",
        sProductAlerts: data?.sProductAlerts || "",
        sProductRequiredEnterAccountNumber:
          data?.sProductRequiredEnterAccountNumber || "",
        repayment_to_account: data?.repayment_to_account || "",
        repayment_account_type: data?.repayment_account_type || "",
        use_repayment_account: data?.use_repayment_account || "",
        sVerifiedFundingSource: data?.sVerifiedFundingSource || "",
      });

      if (data?.repayment_ach == "NO") {
        setShowRepaymentStep2(false);
        setShowRepaymentStep3(false);
        setShowRepaymentStep4(false);
        setShowRepaymentStep5(false);
        setShowRepaymentStep6(false);
      } else {
        setShowRepaymentStep2(true);
        setShowRepaymentStep3(true);
      }
      if (data?.repayment_smart_ach == "NO-outside") {
        setShowRepaymentStep4(false);
        setShowRepaymentStep5(false);
        setShowRepaymentStep6(false);
      } else if (data?.repayment_smart_ach == "YES") {
        setShowRepaymentStep4(true);
        setShowRepaymentStep5(true);
        setShowRepaymentStep6(true);
      } else if (data?.repayment_smart_ach == "NO") {
        setShowRepaymentStep4(true);
        setShowRepaymentStep5(true);
        setShowRepaymentStep6(false);
      }
      if (data?.repayment_to_account == "repayment_lender_account") {
        setShowRepaymentStep5AccountId(true);
        setShowRepaymentStep5AccountType(false);
      } else {
        setShowRepaymentStep5AccountId(false);
        setShowRepaymentStep5AccountType(true);
      }
    }
  }, [data, reset]);
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  const handleSaveClick = () => {
    const formData: any = getValues();
    formData.saveAction = sectionName;
    // console.log("Form data:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  const updateFieldValue = (name: string, value: string) => {
    setValue(name as any, value, {
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  //repayment 值的变化互相影响
  const onChangeRepaymentStep1 = (repaymentAchValue: string) => {
    if (repaymentAchValue == "NO") {
      updateFieldValue("repayment_smart_ach", "NO"); //step 2
      updateFieldValue("repayment_collect", "NO"); //step 3
      updateFieldValue("sProductAlerts", ""); //step 4
      updateFieldValue("sProductRequiredEnterAccountNumber", ""); //step 4
      updateFieldValue("repayment_to_account", ""); //step 5
      updateFieldValue("use_repayment_account", ""); //step 6
    }
  };
  const onChangeRepaymentStep2 = (repaymentSmartAchValue: string) => {
    if (repaymentSmartAchValue == "NO-outside") {
      updateFieldValue("sProductAlerts", ""); //step 4
      updateFieldValue("repayment_to_account", ""); //step 5
      updateFieldValue("use_repayment_account", ""); //step 6
    } else if (repaymentSmartAchValue == "NO") {
      updateFieldValue("sVerifiedFundingSource", ""); //step 6
    }
  };

  return (
    <SectionStyled id={"section_" + sectionName}>
      <SectionTitle subtitle={sectionSubtitle} title={sectionTitle} />
      <Box
        sx={{
          padding: "10px",
          height: "calc(100vh - 255px)",
          overflowY: "auto",
          // background: "yellow",
        }}
      >
        <Box id="serviceRepaymentSection">
          <Grid
            container
            sx={{ backgroundColor: "#f5f5f5", padding: "10px", mb: 3, mt: 2 }}
          >
            <Grid item xs={12}>
              <FieldTitle
                title={
                  productType == "account"
                    ? "Deposit - Process for initial deposit"
                    : "Repayment – Requirements for collecting repayments"
                }
              />
            </Grid>
          </Grid>
          {/* Step 1 */}
          <Grid container spacing={2} sx={{ mb: 1 }}>
            <Grid item xs={12}>
              <Controller
                name={`repayment_ach`}
                // defaultValue={textreader}
                control={control}
                render={({ field }) => (
                  <CustomProductSelect
                    {...field}
                    sx={{ maxWidth: "800px" }}
                    label={
                      productType == "account"
                        ? "1. Will the initial deposit be made through ACH?"
                        : "1. Will repayment be collected through ACH?"
                    }
                    variant="outlined"
                    optionlist={[
                      { value: "YES", label: "YES" },
                      { value: "NO", label: "NO" },
                    ]}
                    onChange={(e) => {
                      const selectedValue = e.target.value.toString();

                      field.onChange(selectedValue);
                      if (selectedValue == "NO") {
                        setShowRepaymentStep2(false);
                        setShowRepaymentStep3(false);
                        setShowRepaymentStep4(false);
                        setShowRepaymentStep5(false);
                        setShowRepaymentStep6(false);
                      } else {
                        setShowRepaymentStep2(true);
                        setShowRepaymentStep3(true);
                      }
                      onChangeRepaymentStep1(selectedValue);
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
          {/* Step 2 */}
          {showRepaymentStep2 && (
            <Grid container spacing={2} sx={{ mb: 1 }}>
              <Grid item xs={12}>
                <Controller
                  name={`repayment_smart_ach`}
                  // defaultValue={textreader}
                  control={control}
                  render={({ field }) => (
                    <CustomProductSelect
                      {...field}
                      sx={{ maxWidth: "800px" }}
                      label={
                        productType == "account"
                          ? "2. Will Happy Mango Smart ACH be used for making the initial deposit?"
                          : "2. Will Happy Mango Automated Smart ACH be used for repayments?"
                      }
                      variant="outlined"
                      optionlist={[
                        { value: "YES", label: "YES" },
                        { value: "NO", label: "No. With Exceptions" },
                        {
                          value: "NO-outside",
                          label:
                            "No. ACH will be processed manually outside of Happy Mango.",
                        },
                      ]}
                      onChange={(e) => {
                        const selectedValue = e.target.value.toString();

                        field.onChange(selectedValue);
                        if (selectedValue == "NO-outside") {
                          setShowRepaymentStep4(false);
                          setShowRepaymentStep5(false);
                          setShowRepaymentStep6(false);
                        } else if (selectedValue == "YES") {
                          setShowRepaymentStep4(true);
                          setShowRepaymentStep5(true);
                          setShowRepaymentStep6(true);
                        } else {
                          setShowRepaymentStep4(true);
                          setShowRepaymentStep5(true);
                          setShowRepaymentStep6(false);
                        }
                        onChangeRepaymentStep2(selectedValue);
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          )}

          {/* Step 3 */}
          {showRepaymentStep3 && (
            <>
              {productType != "account" && (
                <>
                  <Grid container spacing={2} sx={{ mb: 1 }}>
                    <Grid item xs={12}>
                      <Controller
                        name={`repayment_collect`}
                        // defaultValue={textreader}
                        control={control}
                        render={({ field }) => (
                          <CustomProductSelect
                            {...field}
                            sx={{ maxWidth: "800px" }}
                            label={
                              "3. Will applicant bank account number be collected on Happy Mango and displayed on a system generated document?"
                            }
                            variant="outlined"
                            optionlist={[
                              { value: "YES", label: "YES" },
                              { value: "NO", label: "NO" },
                            ]}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} sx={{ mb: 1 }}>
                    <Grid item xs={12}>
                      <Controller
                        name={`sProductRequiredEnterAccountNumber`}
                        control={control}
                        render={({ field }) => (
                          <CustomProductSelect
                            {...field}
                            sx={{ maxWidth: "800px" }}
                            label={
                              "4. Will the loan officer be required to enter the account number during application review?"
                            }
                            variant="outlined"
                            optionlist={[
                              {
                                value: "YES",
                                label: "YES",
                              },
                              { value: "NO", label: "NO" },
                            ]}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </>
              )}
              {productType == "account" && (
                <Grid container spacing={2} sx={{ mb: 1 }}>
                  <Grid item xs={12}>
                    <Controller
                      name={`deposit_collect`}
                      // defaultValue={textreader}
                      control={control}
                      render={({ field }) => (
                        <CustomProductSelect
                          {...field}
                          sx={{ maxWidth: "800px" }}
                          label={
                            "3. Will applicant bank account number be collected on Happy Mango and displayed on a system generated document?"
                          }
                          variant="outlined"
                          optionlist={[
                            { value: "YES", label: "YES" },
                            { value: "NO", label: "NO" },
                          ]}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              )}
            </>
          )}

          {/* Step 4 */}
          {showRepaymentStep4 && productType != "account" && (
            <>
              <Grid container spacing={2} sx={{ mb: 1 }}>
                <Grid item xs={12}>
                  <Controller
                    name={`sProductAlerts`}
                    control={control}
                    render={({ field }) => (
                      <CustomProductSelect
                        {...field}
                        sx={{ maxWidth: "800px" }}
                        label={
                          "5. Should Happy Mango send borrower payment invoice 5 days before the payment is due?"
                        }
                        variant="outlined"
                        optionlist={[
                          {
                            value: "event_pmt_transfer_scheduled",
                            label: "YES",
                          },
                          { value: "NO", label: "NO" },
                        ]}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </>
          )}

          {/* Step 5 */}
          {showRepaymentStep5 && (
            <Grid container spacing={1} sx={{ mb: 0 }}>
              <Grid item xs={9}>
                <Controller
                  name={`repayment_to_account`}
                  control={control}
                  render={({ field }) => (
                    <CustomProductSelect
                      {...field}
                      sx={{ maxWidth: "800px" }}
                      label={
                        productType == "account"
                          ? "6. Provide detail on destination account used for receiving the initial deposit"
                          : "6. Please select destination account used for receiving repayments from your customers"
                      }
                      variant="outlined"
                      optionlist={[
                        {
                          value: "repayment_user_account",
                          label:
                            "Individual's account opened by my institution",
                        },
                        {
                          value: "repayment_lender_account",
                          label:
                            "My institution's account for processing customer repayments. Select account below.",
                        },
                      ]}
                      onChange={(e) => {
                        const selectedValue = e.target.value.toString();

                        field.onChange(selectedValue);
                        if (selectedValue == "repayment_lender_account") {
                          setShowRepaymentStep5AccountId(true);
                          setShowRepaymentStep5AccountType(false);
                        } else {
                          setShowRepaymentStep5AccountId(false);
                          setShowRepaymentStep5AccountType(true);
                        }
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                {showRepaymentStep5AccountType && (
                  <Controller
                    name={`repayment_account_type`}
                    control={control}
                    render={({ field }) => (
                      <CustomProductSelect
                        {...field}
                        label="Account Type"
                        variant="outlined"
                        optionlist={[
                          {
                            value: "savings",
                            label: "Savings",
                          },
                          {
                            value: "checking",
                            label: "Checking",
                          },
                          {
                            value: "loan",
                            label: "Loan",
                          },
                        ]}
                      />
                    )}
                  />
                )}
              </Grid>
              {showRepaymentStep5AccountId && (
                <Grid item xs={12} sx={{ mt: 0, mb: 0 }}>
                  <Controller
                    name={`use_repayment_account`}
                    control={control}
                    render={({ field }) => (
                      <CustomProductSelect
                        {...field}
                        sx={{ maxWidth: "800px" }}
                        label="Select Account"
                        variant="outlined"
                        optionlist={accountRepaymentOptions}
                      />
                    )}
                  />
                </Grid>
              )}
            </Grid>
          )}
          {showRepaymentStep6 && productType != "account" && (
            <Grid container spacing={2} sx={{ mb: 1, mt: "-7px" }}>
              <Grid item xs={12}>
                <Controller
                  name={`sVerifiedFundingSource`}
                  control={control}
                  render={({ field }) => (
                    <CustomProductSelect
                      {...field}
                      sx={{ maxWidth: "800px" }}
                      label={
                        "7. Is repayment funding source verified upon closing?"
                      }
                      variant="outlined"
                      optionlist={[
                        { value: "Verified", label: "YES" },
                        { value: "LateVerified", label: "NO" },
                      ]}
                    />
                  )}
                />
              </Grid>
            </Grid>
          )}
        </Box>
      </Box>
      <CustomProductActionBottom>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveClick}
          disabled={!isDirty}
          sx={{ width: "120px", mt: 1 }}
        >
          Save
        </Button>
      </CustomProductActionBottom>
    </SectionStyled>
  );
}
